import StoreLayout from './StoreLayout'
import Grid from '@mui/joy/Grid'
import { useGetAllStoresQuery } from '../services/stores'
import React from 'react'
import StoreLoading from './StoreLoading'

function AllStores() {
  const { data: allStores, isLoading: allStoresLoading } =
    useGetAllStoresQuery()

  if (allStoresLoading) {
    return (
      <>
        <Grid sx={{ pb: 2 }}>
          <StoreLoading />
        </Grid>
        <Grid sx={{ pb: 2 }}>
          <StoreLoading />
        </Grid>
        <Grid sx={{ pb: 2 }}>
          <StoreLoading />
        </Grid>
      </>
    )
  }

  return (
    <Grid>
      {allStores?.map((value) => (
        <Grid key={value.id} sx={{ pb: 2 }}>
          <StoreLayout store={value} isAddEnabled={true} />
        </Grid>
      ))}
    </Grid>
  )
}

export default AllStores
